import React, {PureComponent} from "react"
import {get} from "lodash"

import {Team} from "@irati/admin/types"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"

import {Container} from "./styled"

interface Props {
  row: Team,
  redemptionsAccessor: string
}

class RedemptionsRenderer extends PureComponent<Props> {
  render() {
    const idNamespace = id("TeamsRenderer", this.props)
    const {row, redemptionsAccessor} = this.props
    const redemptions = get(row, redemptionsAccessor)

    return (
      <Flex id={idNamespace}>
        <Container width={30}>{redemptions}</Container>
      </Flex>
    )
  }
}

export default RedemptionsRenderer
